module.exports = __webpack_public_path__ + "img/or.be5030ca.webp";